<template>
  <rt-popover
    v-model="visible"
    v-bind="$attrs"
    trigger="click"
  >
    <div class="el-popconfirm">
      <p class="el-popconfirm__main">
        <rt-icon
          v-if="!hideIcon"
          :name="icon"
          :size="iconSize"
          :style="{color: iconColor}"
        />
        <template>
          <div class="rt-popconfirm__title">
            {{ title }}
          </div>
        </template>
      </p>
      <div class="el-popconfirm__action">
        <rt-button
          v-bind="$attrs"
          :text="cancelTextShow"
          :type="cancelButtonType"
          @click="cancel"
        >
          {{ displayCancelButtonText }}
        </rt-button>
        <rt-button
          v-bind="$attrs"
          :type="confirmButtonType"
          @click="confirm"
        >
          {{ displayConfirmButtonText }}
        </rt-button>
      </div>
    </div>
    <slot
      slot="reference"
      name="reference"
    ></slot>
  </rt-popover>
</template>

<script>

import RtButton from 'vue-xpc/src/components/button/rtButton';

export default {
  name: 'ElPopconfirm',
  components: { RtButton },
  props: {
    title: {
      type: String
    },
    confirmButtonText: {
      type: String
    },
    cancelButtonText: {
      type: String
    },
    confirmButtonType: {
      type: String,
      default: 'primary'
    },
    cancelButtonType: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      // default: 'el-icon-question'
      default: 'rt-base-circle-warning-filled'
    },
    iconColor: {
      type: String,
      default: '#f90'
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: Number,
      default: 16
    },
    // 取消按钮的样式默认为文字按钮展示
    cancelTextShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false
    };
  },
  computed: {
    displayConfirmButtonText () {
      return this.confirmButtonText || this.$tx('确定', 'xpc.common.ok');
    },
    displayCancelButtonText () {
      return this.cancelButtonText || this.$tx('取消', 'xpc.common.cancel');
    }
  },
  methods: {
    confirm () {
      this.visible = false;
      this.$emit('confirm');
    },
    cancel () {
      this.visible = false;
      this.$emit('cancel');
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?379fab42